/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { withTheme } from "@material-ui/core/styles";
const Footer = ({ theme }) => {
  return (
    <Grid
      item
      style={{
        flex: "0 0 30px",
        backgroundColor: `${theme.palette.grey[300]}`,
      }}
    >
      <Typography
        component="p"
        display="block"
        variant="caption"
        style={{ textAlign: "center", marginTop: "8px", marginBottom: "8px" }}
      >
        Proprietary and Confidential Material. Distribution, Use, Duplication,
        and Disclosure Restricted by License. Copyright 2020. United Parcel
        Service of America, INC. All Rights Reserved.
        <a href="https://www.ups.com/us/en/help-center/legal-terms-conditions/technology-agreement.page">
          Terms Of Use
        </a>
      </Typography>
    </Grid>
  );
};

export default withTheme(Footer);
